<cutting-panel-list-table
  #table
  [materials]="materials"
  [editablePanelUuid]="editablePanelUuid"
  [editMode]="editMode"
  [disabled]="disabled"
  [cuttingSettings]="cuttingSettings"
  (copying)="copy($event)"
  (deleting)="delete($event)"
  (editing)="edit($event)"
  (changeMaterial)="changeMaterial($event)"
  (changeEdges)="changeEdges($event)"></cutting-panel-list-table>
